import plantDataConfigApi from '@/api/config/plantDataConfigApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { NotifyService } from '@/helpers'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function deletePlant(interfaceId: string, id: string): Promise<void> {
  await plantDataConfigApi.delete(interfaceId, id)
}

function useDeletePlant() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation(
    (payload: any) => deletePlant(payload.interfaceId, payload.id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.plant])
        toast.success(t('deletePlantSuccess'))
        closeModal()
      },
      onError: (error: any) => {
        NotifyService.error(error)
        closeModal()
      },
    },
  )

  // return mutate
}

export default useDeletePlant
